// extracted by mini-css-extract-plugin
export var orderSummary = "_t2-0";
export var showMoreLessButton = "_t2-1";